import { publicDataSelectors } from '_core/store/PublicData'
import { findInObject } from '_core/utils/findInObject'
import { makeActionCreator } from '_core/utils/actions'

// === Action types ===

const THEME_RESET = 'THEME_RESET'
const THEME_CHANGE = 'THEME_CHANGE'
const THEME_UPDATE = 'THEME_UPDATE'

// === Default state ===

const defaultState = {
  current: null,
  list: null,
}

// === Selectors ===

const getThemeList = store => publicDataSelectors.getTheme(store).list

const getCurrentThemeId = store => publicDataSelectors.getTheme(store).current

const getThemeInfoById = (store, themeId) => {
  const list = getThemeList(store)
  return list != null ? findInObject(list, 'id', themeId) : null
}

// === Actions ===

const changeTheme = makeActionCreator(THEME_CHANGE, 'id')

const updateTheme = makeActionCreator(THEME_UPDATE, 'data')

const resetTheme = makeActionCreator(THEME_RESET)

// === Exports ===

export const themeDefaultState = defaultState

export const themeActionTypes = {
  THEME_RESET,
  THEME_CHANGE,
  THEME_UPDATE,
}

export const themeSelectors = {
  getThemeList,
  getCurrentThemeId,
  getThemeInfoById,
}

export const themeActions = {
  changeTheme,
  updateTheme,
  resetTheme,
}
